<template>
  <v-data-table
    v-bind="tableProps"
    dense
    :headers="headers"
    :items="data"
    :loading="loading"
    @click:row="onRowClick"
  >
    <template v-slot:[`item.warehouse_id`]="{ item }">
      {{ item.warehouse_id[1] }}
    </template>
    <template v-slot:[`item.pos_type_id`]="{ item }">
      {{ item.pos_type_id ? item.pos_type_id[1] : $t("_.none") }}
    </template>
  </v-data-table>
</template>

<script>
import { get } from "lodash";
import { inject } from "vue-demi";
import { useDataTable } from "@/composables/api/data-table.js";

export default {
  setup() {
    const { data, loading, headers, tableProps } = useDataTable("potential");

    const showOnMap = inject("showOnMap");

    const onRowClick = item => {
      showOnMap({
        measure: "potential",
        warehouse_id: item.warehouse_id[0],
        pos_type_id: get(item.pos_type_id, "[0]", null)
      });
    };

    return {
      data,
      loading,
      headers,
      onRowClick,
      tableProps
    };
  }
};
</script>

<style></style>
